export const pxToRem = (px: number) => (px ? `${px / 16}rem` : '0');
export const sleep = (s: number) =>
  new Promise((r) => {
    setTimeout(r, s * 1000);
  });
